// Official visa check URLs for countries
// Updated December 2025 - Verified official government visa portals
// This centralized configuration ensures users always get correct official links

export const OFFICIAL_VISA_URLS: Record<string, string> = {
  // North America
  'United States': 'https://travel.state.gov/content/travel/en/us-visas.html',
  'USA': 'https://travel.state.gov/content/travel/en/us-visas.html',
  'US': 'https://travel.state.gov/content/travel/en/us-visas.html',
  'Canada': 'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada.html',
  'Mexico': 'https://www.gob.mx/tramites/ficha/visa-de-visitante-sin-permiso-para-realizar-actividades-remuneradas/SRE185',
  
  // United Kingdom
  'United Kingdom': 'https://www.gov.uk/check-uk-visa',
  'UK': 'https://www.gov.uk/check-uk-visa',
  'Great Britain': 'https://www.gov.uk/check-uk-visa',
  'England': 'https://www.gov.uk/check-uk-visa',
  'Scotland': 'https://www.gov.uk/check-uk-visa',
  'Wales': 'https://www.gov.uk/check-uk-visa',
  
  // Oceania
  'Australia': 'https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-finder',
  'New Zealand': 'https://www.immigration.govt.nz/new-zealand-visas',
  'Fiji': 'https://www.immigration.gov.fj/fiji-visas/',
  'Papua New Guinea': 'https://ica.gov.pg/visa/visit/visitor',
  'Samoa': 'https://www.samoaimmigration.gov.ws/',
  'Tonga': 'https://www.revenue.gov.to/immigration-and-general-services',
  'Vanuatu': 'https://immigration.gov.vu/tourist-visa/',
  
  // Schengen Area (main portal)
  'Schengen': 'https://www.schengenvisainfo.com/apply-schengen-visa/',
  
  // European Countries
  'Albania': 'https://e-visa.al/',
  'Andorra': 'https://visitandorra.com/en/practical-information/entry-requirements/',
  'Austria': 'https://www.bmeia.gv.at/en/travel-stay/entrance-and-residence-in-austria/visa',
  'Belarus': 'https://mfa.gov.by/en/visa/',
  'Belgium': 'https://diplomatie.belgium.be/en/travel-belgium/visa-belgium',
  'Bosnia and Herzegovina': 'https://www.mvp.gov.ba/',
  'Bosnia & Herzegovina': 'https://www.mvp.gov.ba/',
  'Bulgaria': 'https://www.mfa.bg/en/services-travel/consular-services/travel-bulgaria/visa-bulgaria',
  'Croatia': 'https://mvep.gov.hr/consular-information-125335/visas-180242/180242',
  'Cyprus': 'https://www.gov.cy/en/information/visas/',
  'Czech Republic': 'https://www.mzv.cz/jnp/en/information_for_aliens/visa_form.html',
  'Czechia': 'https://www.mzv.cz/jnp/en/information_for_aliens/visa_form.html',
  'Denmark': 'https://www.nyidanmark.dk/en-GB/Applying/Short%20stay%20visa',
  'Estonia': 'https://www.vm.ee/en/consular-visa-and-travel-information/visa-information',
  'Finland': 'https://um.fi/visa-to-finland',
  'France': 'https://france-visas.gouv.fr/en/web/france-visas/',
  'Germany': 'https://www.auswaertiges-amt.de/en/visa-service',
  'Greece': 'https://www.mfa.gr/en/visas/',
  'Hungary': 'https://konzuliszolgalat.kormany.hu/en/schengen-visa',
  'Iceland': 'https://www.government.is/topics/foreign-affairs/visa-to-iceland/',
  'Ireland': 'https://www.irishimmigration.ie/coming-to-visit-ireland/',
  'Italy': 'https://vistoperitalia.esteri.it/home/en',
  'Kosovo': 'https://evisa.rks-gov.net/',
  'Latvia': 'https://www.mfa.gov.lv/en/visa-information',
  'Liechtenstein': 'https://www.llv.li/en/national-administration/office-of-immigration-and-passports/visas',
  'Lithuania': 'https://www.urm.lt/default/en/consular-information/visas',
  'Luxembourg': 'https://maee.gouvernement.lu/en/services-aux-citoyens/visa-pour-le-luxembourg.html',
  'Malta': 'https://www.identitymalta.com/services/central-visa-unit/',
  'Moldova': 'https://www.evisa.gov.md/',
  'Monaco': 'https://en.service-public-particuliers.gouv.mc/Residency/Entry-and-residency/Entering-Monaco/Visa',
  'Montenegro': 'https://www.gov.me/en/diplomatic-missions/visa',
  'Netherlands': 'https://www.netherlandsworldwide.nl/visa-the-netherlands/schengen-visa',
  'North Macedonia': 'https://www.mfa.gov.mk/en/page/15/visas',
  'Norway': 'https://www.udi.no/en/want-to-apply/visit-and-holiday/',
  'Poland': 'https://www.gov.pl/web/diplomacy/visas',
  'Portugal': 'https://vistos.mne.gov.pt/en/',
  'Romania': 'https://evisa.mae.ro/',
  'Russia': 'https://electronic-visa.kdmid.ru/',
  'San Marino': 'https://www.esteri.sm/en/services/entry-and-stay-in-san-marino/',
  'Serbia': 'https://www.mfa.gov.rs/en/citizens/travel-serbia/visa-regime',
  'Slovakia': 'https://www.mzv.sk/en/services/information-for-foreigners/visas',
  'Slovenia': 'https://www.gov.si/en/topics/entry-and-residence/',
  'Spain': 'https://www.exteriores.gob.es/en/Paginas/index.aspx',
  'Sweden': 'https://www.migrationsverket.se/English/Private-individuals/Visiting-Sweden.html',
  'Switzerland': 'https://www.sem.admin.ch/sem/en/home/themen/einreise.html',
  'Ukraine': 'https://mfa.gov.ua/en/consular-affairs/entry-and-stay-foreigners-ukraine',
  'Vatican City': 'https://vistoperitalia.esteri.it/home/en', // Same as Italy
  
  // South America
  'Argentina': 'https://www.argentina.gob.ar/interior/migraciones/tramites-migraciones/ingreso',
  'Bolivia': 'https://tramites.cancilleria.gob.bo/',
  'Brazil': 'https://www.gov.br/mre/en/subjects/consular-and-legal/consular-services/visas-for-foreigners',
  'Chile': 'https://serviciosconsulares.cl/tramites/visa-de-turismo',
  'Colombia': 'https://www.cancilleria.gov.co/tramites_servicios/visa',
  'Ecuador': 'https://www.cancilleria.gob.ec/visas/',
  'Guyana': 'https://eservices.iss.gov.gy/visitor-visa',
  'Paraguay': 'https://www.migraciones.gov.py/',
  'Peru': 'https://www.gob.pe/en/services',
  'Suriname': 'https://suriname.vfsevisa.com/suriname/online/home/index',
  'Uruguay': 'https://www.gub.uy/tramites/visa-turismo',
  'Venezuela': 'https://mppre.gob.ve/',
  
  // Central America & Caribbean
  'Belize': 'https://immigration.gov.bz/visa/visa-who-qualify/',
  'Costa Rica': 'https://www.migracion.go.cr/',
  'Cuba': 'https://misiones.cubaminrex.cu/',
  'Dominican Republic': 'https://portal.dgm.gob.do/',
  'El Salvador': 'https://www.migracion.gob.sv/',
  'Guatemala': 'https://igm.gob.gt/',
  'Honduras': 'https://www.inm.gob.hn/',
  'Nicaragua': 'https://www.migracion.gob.ni/',
  'Panama': 'https://www.migracion.gob.pa/',
  'Jamaica': 'https://www.pica.gov.jm/immigration/entry-visa-requirements/',
  'Bahamas': 'https://www.bahamas.com/plan-your-trip/island-faq/visa-immigration',
  'Barbados': 'https://www.immigration.gov.bb/',
  'Trinidad and Tobago': 'https://nationalsecurity.gov.tt/divisions/immigration-division/',
  
  // East Asia
  'Japan': 'https://www.mofa.go.jp/j_info/visit/visa/',
  'China': 'https://www.visaforchina.cn/',
  'South Korea': 'https://www.visa.go.kr/main/openMain.do?locale=en',
  'Taiwan': 'https://www.boca.gov.tw/mp-2.html',
  'Hong Kong': 'https://www.immd.gov.hk/eng/services/visas/visit-transit/visit-visa-entry-permit.html',
  'Macau': 'https://www.fsm.gov.mo/psp/eng/',
  'Mongolia': 'https://immigration.gov.mn/en/visa-information/',
  
  // Southeast Asia
  'Thailand': 'https://www.thaievisa.go.th/',
  'Vietnam': 'https://evisa.xuatnhapcanh.gov.vn/',
  'Indonesia': 'https://visa-online.imigrasi.go.id/',
  'Malaysia': 'https://www.imi.gov.my/index.php/en/main-services/visa/',
  'Singapore': 'https://www.ica.gov.sg/enter-transit-depart/entering-singapore/visa_requirements',
  'Philippines': 'https://evisa.gov.ph/',
  'Myanmar': 'https://evisa.moip.gov.mm/',
  'Burma': 'https://evisa.moip.gov.mm/',
  'Cambodia': 'https://www.evisa.gov.kh/',
  'Laos': 'https://laoevisa.gov.la/',
  'Brunei': 'https://www.immigration.gov.bn/',
  'Timor-Leste': 'https://migracao.gov.tl/html/sub0301.php',
  'East Timor': 'https://migracao.gov.tl/html/sub0301.php',
  
  // South Asia
  'India': 'https://indianvisaonline.gov.in/',
  'Pakistan': 'https://visa.nadra.gov.pk/',
  'Bangladesh': 'https://visa.gov.bd/',
  'Sri Lanka': 'https://www.srilankaevisa.lk/',
  'Ceylon': 'https://www.srilankaevisa.lk/',
  'Nepal': 'https://nepalonlinevisa.gov.np/',
  'Bhutan': 'https://www.tourism.gov.bt/',
  'Maldives': 'https://immigration.gov.mv/',
  'Afghanistan': 'https://evisa.mfa.gov.af/',
  
  // Central Asia
  'Kazakhstan': 'https://www.vmp.gov.kz/',
  'Uzbekistan': 'https://e-visa.gov.uz/',
  'Turkmenistan': 'https://www.mfa.gov.tm/en',
  'Kyrgyzstan': 'https://evisa.e-gov.kg/',
  'Tajikistan': 'https://www.evisa.tj/',
  
  // Middle East
  'United Arab Emirates': 'https://icp.gov.ae/en/services/visa/',
  'UAE': 'https://icp.gov.ae/en/services/visa/',
  'Emirates': 'https://icp.gov.ae/en/services/visa/',
  'Turkey': 'https://www.evisa.gov.tr/en/',
  'Saudi Arabia': 'https://visa.visitsaudi.com/',
  'Qatar': 'https://www.visitqatar.com/intl-en/practical-info/visa-information',
  'Oman': 'https://evisa.rop.gov.om/',
  'Kuwait': 'https://evisa.moi.gov.kw/',
  'Bahrain': 'https://www.evisa.gov.bh/',
  'Jordan': 'https://www.jordanpass.jo/',
  'Lebanon': 'https://www.general-security.gov.lb/en/posts/38',
  'Iraq': 'https://evisa.iq/',
  'Iran': 'https://evisa.mfa.ir/',
  'Persia': 'https://evisa.mfa.ir/',
  'Armenia': 'https://evisa.mfa.am/',
  'Azerbaijan': 'https://evisa.gov.az/',
  'Georgia': 'https://www.evisa.gov.ge/',
  'Israel': 'https://israel-entry.piba.gov.il/',
  
  // Africa - North
  'Egypt': 'https://visa2egypt.gov.eg/',
  'Morocco': 'https://www.consulat.ma/en/',
  'Tunisia': 'https://www.diplomatie.gov.tn/',
  'Algeria': 'https://www.mae.gov.dz/services-for-foreigners/entry-visa-to-algeria',
  'Libya': 'https://evisa.gov.ly/',
  
  // Africa - East
  'Kenya': 'https://evisa.go.ke/',
  'Ethiopia': 'https://www.evisa.gov.et/',
  'Tanzania': 'https://visa.immigration.go.tz/',
  'Uganda': 'https://visas.immigration.go.ug/',
  'Rwanda': 'https://irembo.gov.rw/',
  'Burundi': 'https://migration.gov.bi/',
  'South Sudan': 'https://evisa.gov.ss/',
  'Djibouti': 'https://www.evisa.gouv.dj/',
  'Eritrea': 'https://www.shabait.com/',
  
  // Africa - West
  'Nigeria': 'https://immigration.gov.ng/visa/',
  'Ghana': 'https://evisa.fi.gov.gh/',
  'Senegal': 'https://www.diplomatie.gouv.sn/',
  'Ivory Coast': 'https://snedai.com/',
  'Côte d\'Ivoire': 'https://snedai.com/',
  'Cameroon': 'https://www.evisacam.cm/',
  'Benin': 'https://evisa.gouv.bj/',
  'Togo': 'https://voyage.gouv.tg/',
  'Burkina Faso': 'https://www.diplomatie.gov.bf/',
  'Mali': 'https://www.diplomatie.gov.ml/',
  'Niger': 'https://www.mae.gov.ne/',
  'Guinea': 'https://www.paf.gov.gn/',
  'Sierra Leone': 'https://www.evisa.sl/',
  'Liberia': 'https://evisa.lis.gov.lr/',
  'Gambia': 'https://www.gid.gov.gm/',
  'Guinea-Bissau': 'https://www.mirex.gov.gw/',
  'Cabo Verde': 'https://ease.gov.cv/',
  
  // Africa - Central
  'Democratic Republic of Congo': 'https://evisa.gouv.cd/',
  'Congo (Kinshasa)': 'https://evisa.gouv.cd/',
  'Congo': 'https://www.dgm.gouv.cg/',
  'Congo (Brazzaville)': 'https://www.dgm.gouv.cg/',
  'Central African Republic': 'https://www.primature.gouv.cf/',
  'Chad': 'https://www.diplomatie.gouv.td/',
  'Gabon': 'https://evisa.dgdi.ga/',
  'Equatorial Guinea': 'https://www.guineaecuatorialpress.com/',
  'São Tomé and Príncipe': 'https://smf.gov.st/',
  
  // Africa - Southern
  'South Africa': 'https://www.dha.gov.za/index.php/immigration-services/visa-information',
  'Zambia': 'https://evisa.zambiaimmigration.gov.zm/',
  'Zimbabwe': 'https://www.evisa.gov.zw/',
  'Botswana': 'https://evisa.gov.bw/',
  'Namibia': 'https://eservices.mhaiss.gov.na/',
  'Mozambique': 'https://evisa.gov.mz/',
  'Madagascar': 'https://evisamada.gov.mg/',
  'Malawi': 'https://evisa.gov.mw/',
  'Mauritius': 'https://passport.govmu.org/',
  'Seychelles': 'https://seychelles.govtas.com/',
  'Angola': 'https://smevisa.gov.ao/',
  'Lesotho': 'https://www.immigration.gov.ls/',
  'Eswatini': 'https://www.gov.sz/',
  'Swaziland': 'https://www.gov.sz/',
  'Comoros': 'https://www.comores-visa.com/',
};

// Country variations and aliases for normalization
export const COUNTRY_ALIASES: Record<string, string> = {
  'usa': 'United States',
  'us': 'United States',
  'united states of america': 'United States',
  'america': 'United States',
  'uk': 'United Kingdom',
  'great britain': 'United Kingdom',
  'england': 'United Kingdom',
  'scotland': 'United Kingdom',
  'wales': 'United Kingdom',
  'northern ireland': 'United Kingdom',
  'uae': 'United Arab Emirates',
  'emirates': 'United Arab Emirates',
  'burma': 'Myanmar',
  'ceylon': 'Sri Lanka',
  'persia': 'Iran',
  'siam': 'Thailand',
  'formosa': 'Taiwan',
  'east timor': 'Timor-Leste',
  'czechia': 'Czech Republic',
  'holland': 'Netherlands',
  'the netherlands': 'Netherlands',
  'korea': 'South Korea',
  'republic of korea': 'South Korea',
  'drc': 'Democratic Republic of Congo',
  'dr congo': 'Democratic Republic of Congo',
  'ivory coast': 'Côte d\'Ivoire',
  'swaziland': 'Eswatini',
  'cape verde': 'Cabo Verde',
};

/**
 * Get official visa URL for a destination country
 * @param destination - The destination country name
 * @returns The official visa URL or null if not found
 */
export function getOfficialVisaUrl(destination: string): string | null {
  const normalized = destination.trim();
  const lowerCase = normalized.toLowerCase();
  
  // Try exact match first
  if (OFFICIAL_VISA_URLS[normalized]) {
    return OFFICIAL_VISA_URLS[normalized];
  }
  
  // Try lowercase match
  const exactMatch = Object.keys(OFFICIAL_VISA_URLS).find(
    key => key.toLowerCase() === lowerCase
  );
  if (exactMatch) {
    return OFFICIAL_VISA_URLS[exactMatch];
  }
  
  // Try alias match
  if (COUNTRY_ALIASES[lowerCase]) {
    const aliasedCountry = COUNTRY_ALIASES[lowerCase];
    return OFFICIAL_VISA_URLS[aliasedCountry] || null;
  }
  
  // Try partial match (contains)
  const partialMatch = Object.keys(OFFICIAL_VISA_URLS).find(
    key => lowerCase.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerCase)
  );
  if (partialMatch) {
    return OFFICIAL_VISA_URLS[partialMatch];
  }
  
  return null;
}

/**
 * Check if a country is in the US Visa Waiver Program (ESTA eligible)
 * Updated December 2025
 */
export const USA_VWP_COUNTRIES = new Set([
  'Andorra', 'Australia', 'Austria', 'Belgium', 'Brunei', 'Chile', 'Croatia',
  'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany',
  'Greece', 'Hungary', 'Iceland', 'Ireland', 'Israel', 'Italy', 'Japan',
  'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta', 'Monaco',
  'Netherlands', 'New Zealand', 'Norway', 'Poland', 'Portugal', 'San Marino',
  'Singapore', 'Slovakia', 'Slovenia', 'South Korea', 'Spain', 'Sweden',
  'Switzerland', 'Taiwan', 'United Kingdom'
]);

/**
 * EU/Schengen countries for visa-free travel between members
 */
export const EU_SCHENGEN_COUNTRIES = new Set([
  'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
  'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary',
  'Iceland', 'Ireland', 'Italy', 'Latvia', 'Liechtenstein', 'Lithuania',
  'Luxembourg', 'Malta', 'Netherlands', 'Norway', 'Poland', 'Portugal',
  'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland'
]);
